<template>
    <div class="form-view password-modal">
        <h2 class="text-center">Ny adgangskode</h2>
        <div class="form">
            <div class="grid-x">
                <div class="banner-lock">
                    <icon class="large-svg fill-white" name="locked" />
                </div>
            </div>
        </div>
        <h6>
            Indtast din nye adgangskode
        </h6>
        <section>
            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="small-svg fill-selected-dark-gray" name="locked" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox align-items">
                        <label for="newPassword">Ny adgangskode</label>
                    </div>
                    <div class="auto cell border-bottom">
                        <input type="password" id="newPassword" @blur="showPasswordErrorNotification()" v-model="newPassword">
                    </div>
                </div>
            </div>

            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="small-svg fill-selected-dark-gray" name="locked" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom border-bottom-last flexbox align-items">
                        <label for="repeatPassword">Gentag ny adgangskode</label>
                    </div>
                    <div class="auto cell border-bottom border-bottom-last">
                        <input type="password" id="repeatPassword" @blur="showPasswordErrorNotification()" v-model="repeatPassword">
                    </div>
                </div>
            </div>
        </section>
        <div class="text-center buttons-modal">
            <a @click="changePassword" :class="{'disabled-button': validatePassword}">Skift</a>
            <a @click="closeModal">Fortryd</a>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'login-modal-forgotpassword',
    props: [
        'data'
    ],
    data () {
        return {
            email: null,
            validEmail: null,
            activeField: false,
            showFeedback: false,
            showPasswordError: false,
            newPassword: null,
            repeatPassword: null
        }
    },
    computed: {
        validatePassword () {
            if (this.newPassword && this.repeatPassword && this.newPassword === this.repeatPassword) {
                this.showPasswordError = false
            } else {
                this.showPasswordError = true
            }
            return this.showPasswordError
        }
    },
    methods: {
        ...mapActions({
            sendResetLink: 'sendResetLink'
        }),
        closeModal () {
            this.$emit('close')
        },
        changePassword () {
            if (this.validEmail) {
                new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(true)
                    }, 2000)
                }).then(() => {
                    this.showFeedback = true
                    setTimeout(() => {
                        this.$emit('close')
                    }, 3000)
                })
            }
        },
        showPasswordErrorNotification () {
            if (this.showPasswordError && this.newPassword && this.repeatPassword) {
                this.$notify({group: 'info', type: 'warn', title: '', text: 'Adgangskoderne er ikke ens. Prøv venligst igen.'})
            }
        }
    },
    created () {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/login-modal-newpassword.vue